<template>
    <div class="col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Zasady programu</h2>

            <p class="dashboard__points dashboard__points--pro">
                Zapoznaj się z zasadami programu, wymiany puntów oraz dowiedz się jak możesz uzyskać status Certyfikowanego Instalatora Geberit Pro.
            </p>

            <div>
                <router-link :to="{name: 'Rules'}" class="button button__bottom">Zobacz zasady &raquo;</router-link>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'RulesWidget',
        props: {
            color: {
                default: 'box--dark-blue'
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/rules/RulesWidget.vue